const RESOURCE_CENTER_ORIGIN = 'https://help.dashsocial.com';

/**
 * Use for authenticated in-app help links; keep public creator-support links direct.
 * Starts Zendesk SSO while preserving the requested article, query and section.
 * Safe to call again when a shared help component receives an already-wrapped URL.
 */
export function getResourceCenterSigninUrl(destination: string): string {
  let url: URL;
  try {
    url = new URL(destination);
  } catch {
    return destination;
  }

  const helpCenterPath = /^\/hc\/([^/]+)(?:\/|$)/.exec(url.pathname);
  if (
    url.origin !== RESOURCE_CENTER_ORIGIN ||
    !helpCenterPath ||
    /^\/hc\/[^/]+\/signin\/?$/.test(url.pathname)
  ) {
    return destination;
  }

  url.pathname = `/hc/${helpCenterPath[1]}/signin`;
  url.search = '';
  url.hash = '';
  url.searchParams.set('return_to', destination);
  return url.href;
}

/** Build a signed-in article link, including any title slug or section anchor. */
export function getResourceCenterArticleUrl(article: string): string {
  return getResourceCenterSigninUrl(`${RESOURCE_CENTER_ORIGIN}/hc/en-us/articles/${article}`);
}

/** Open from the user's click so the browser permits the new tab. */
export function openResourceCenter(destination: string): void {
  if (destination) {
    window.open(getResourceCenterSigninUrl(destination), '_blank', 'noopener');
  }
}
